// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WeeklyPostGenerator Styles */

.weekly-posts-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
}

/* ── Tab Navigation ── */

.posts-tabs {
    display: flex;
    gap: 0;
    border-bottom: 2px solid #e2e8f0;
    margin-bottom: 2rem;
}

.posts-tab-btn {
    position: relative;
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    font-weight: 600;
    color: #94a3b8;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    white-space: nowrap;
}

.posts-tab-btn:hover {
    color: #475569;
}

.posts-tab-btn.active {
    color: #4f46e5;
}

.posts-tab-btn.active::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background: #4f46e5;
    border-radius: 2px 2px 0 0;
}

.posts-tab-btn .tab-icon {
    font-size: 1.1rem;
}

.posts-tab-btn .tab-count {
    background: #e0e7ff;
    color: #4338ca;
    padding: 0.1rem 0.5rem;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 700;
    min-width: 20px;
    text-align: center;
}

/* ── Scheduled Posts Tab ── */

.scheduled-posts-section {
    margin-top: 0;
}

.scheduled-posts-filters {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
}

.filter-btn {
    padding: 0.4rem 1rem;
    font-size: 0.82rem;
    font-weight: 600;
    border: 1.5px solid #e2e8f0;
    border-radius: 9999px;
    background: #fff;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s;
}

.filter-btn:hover {
    border-color: #93c5fd;
    color: #3b82f6;
}

.filter-btn.active {
    background: #4f46e5;
    color: #fff;
    border-color: #4f46e5;
}

.scheduled-posts-empty {
    text-align: center;
    padding: 3rem 1rem;
    color: #94a3b8;
}

.scheduled-posts-empty .empty-icon {
    font-size: 3rem;
    margin-bottom: 0.75rem;
}

.scheduled-posts-empty p {
    font-size: 1rem;
    margin: 0;
}

.scheduled-post-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 1.25rem 1.5rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: flex-start;
    gap: 1.25rem;
    transition: box-shadow 0.2s;
}

.scheduled-post-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.scheduled-post-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 60px;
    padding: 0.5rem 0.75rem;
    background: #f1f5f9;
    border-radius: 10px;
    flex-shrink: 0;
}

.scheduled-post-date .date-day {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1e293b;
    line-height: 1;
}

.scheduled-post-date .date-month {
    font-size: 0.7rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    margin-top: 0.15rem;
}

.scheduled-post-body {
    flex: 1 1;
    min-width: 0;
}

.scheduled-post-body .post-meta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    flex-wrap: wrap;
}

.scheduled-post-body .caption-text {
    font-size: 0.9rem;
    color: #334155;
    line-height: 1.5;
    margin: 0 0 0.5rem 0;
    white-space: pre-wrap;
    word-break: break-word;
}

.scheduled-post-body .hashtags {
    margin-top: 0.25rem;
}

.scheduled-post-actions {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
}

.scheduled-post-card .platform-icons {
    display: flex;
    gap: 0.35rem;
    font-size: 1rem;
}

.status-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.2rem 0.65rem;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 600;
}

.status-pill.pill-approved {
    background: rgba(34, 197, 94, 0.1);
    color: #16a34a;
}

.status-pill.pill-queued {
    background: rgba(59, 130, 246, 0.1);
    color: #2563eb;
}

.status-pill.pill-published {
    background: rgba(16, 185, 129, 0.1);
    color: #059669;
}

.status-pill.pill-publishing {
    background: rgba(99, 102, 241, 0.12);
    color: #4338ca;
    animation: publishing-pulse 1.4s ease-in-out infinite;
}

@keyframes publishing-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.55; }
}

/* Publish-Now banner — shown above the scheduled-posts list while a
   post is being promoted to immediate publication, and remains visible
   until the worker reaches a terminal state. */
.publish-notification {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-radius: 10px;
    margin-bottom: 1rem;
    font-size: 0.92rem;
    font-weight: 500;
    border: 1px solid transparent;
    animation: publish-notification-fade-in 0.25s ease-out;
}

@keyframes publish-notification-fade-in {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
}

.publish-notification-icon {
    font-size: 1.1rem;
    flex-shrink: 0;
}

.publish-notification-message {
    flex: 1 1;
    line-height: 1.4;
}

.publish-notification-close {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 1.25rem;
    line-height: 1;
    padding: 0 0.25rem;
    color: inherit;
    opacity: 0.6;
    flex-shrink: 0;
}

.publish-notification-close:hover {
    opacity: 1;
}

.publish-notification-info {
    background: rgba(99, 102, 241, 0.1);
    color: #4338ca;
    border-color: rgba(99, 102, 241, 0.25);
}

.publish-notification-success {
    background: #d1fae5;
    color: #065f46;
    border-color: #6ee7b7;
}

.publish-notification-partial {
    background: rgba(251, 146, 60, 0.12);
    color: #c2410c;
    border-color: rgba(251, 146, 60, 0.35);
}

.publish-notification-error {
    background: #fee2e2;
    color: #991b1b;
    border-color: #fca5a5;
}

.status-pill.pill-rejected {
    background: rgba(220, 53, 69, 0.08);
    color: #dc3545;
}

.status-pill.pill-failed {
    background: rgba(220, 53, 69, 0.08);
    color: #dc3545;
}

.status-pill.pill-pending_validation {
    background: rgba(251, 191, 36, 0.1);
    color: #d97706;
}

.status-pill.pill-generating {
    background: rgba(99, 102, 241, 0.1);
    color: #6366f1;
}

.status-pill.pill-draft {
    background: #f1f5f9;
    color: #64748b;
}

.status-pill.pill-partially_published {
    background: rgba(251, 146, 60, 0.12);
    color: #c2410c;
}

/* ── Platform icon badges (per-platform status on post card) ── */
.platform-icon-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 1rem;
    transition: opacity 0.2s;
}

.platform-icon-badge.platform-ok::after {
    content: '✓';
    position: absolute;
    bottom: -2px;
    right: -4px;
    font-size: 0.55rem;
    font-weight: 700;
    color: #16a34a;
    background: #dcfce7;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

.platform-icon-badge.platform-fail {
    opacity: 0.6;
}

.platform-icon-badge.platform-fail::after {
    content: '✗';
    position: absolute;
    bottom: -2px;
    right: -4px;
    font-size: 0.55rem;
    font-weight: 700;
    color: #dc2626;
    background: #fee2e2;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}

/* ── Per-platform error detail rows ── */
.platform-results-detail {
    margin-top: 0.6rem;
    padding: 0.6rem 0.75rem;
    background: #fafafa;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.platform-result-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.8rem;
    line-height: 1.4;
}

.platform-result-icon {
    font-size: 0.95rem;
    flex-shrink: 0;
}

.platform-result-name {
    font-weight: 600;
    color: #334155;
    min-width: 70px;
    flex-shrink: 0;
}

.platform-result-status {
    flex: 1 1;
    min-width: 0;
}

.platform-result-status.ok {
    color: #16a34a;
    font-weight: 500;
}

.platform-result-status.error {
    color: #dc2626;
    word-break: break-word;
}

.platform-result-row.result-ok {
    opacity: 0.75;
}

.platform-result-row.result-error {
    background: rgba(220, 38, 38, 0.04);
    padding: 0.3rem 0.5rem;
    border-radius: 6px;
    margin: 0 -0.25rem;
}

@media (max-width: 640px) {
    .scheduled-post-card {
        flex-direction: column;
        gap: 0.75rem;
    }

    .scheduled-post-date {
        flex-direction: row;
        gap: 0.5rem;
        min-width: unset;
    }

    .posts-tabs {
        overflow-x: auto;
    }
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
}

.batch-info {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.week-label {
    font-size: 1rem;
    color: #64748b;
}

.tone-badge {
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-size: 0.8rem;
    font-weight: 600;
    background: #fef3c7;
    color: #92400e;
    border: 1px solid #fcd34d;
}

.status-badge {
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
}

.status-badge.status-draft {
    background: #fef3c7;
    color: #92400e;
}

.status-badge.status-confirmed,
.status-badge.status-generating {
    background: #dbeafe;
    color: #1e40af;
}

.status-badge.status-completed {
    background: #d1fae5;
    color: #065f46;
}

.status-badge.status-failed {
    background: #fee2e2;
    color: #991b1b;
}

/* Prerequisites */
.prerequisites-warning {
    background: #fffbeb;
    border: 1px solid #fbbf24;
    border-radius: 12px;
    padding: 2rem;
    margin-top: 1rem;
}

.prereq-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 0;
}

.prereq-item.missing {
    color: #dc2626;
}

/* Generate Section */
.generate-section {
    text-align: center;
    padding: 4rem 2rem;
}

.generate-section p {
    color: #64748b;
    max-width: 480px;
    margin: 1rem auto 2rem;
    line-height: 1.6;
}

/* Tone Selector */
.tone-selector {
    max-width: 700px;
    margin: 0 auto 2rem;
}

/* Target Audience Selector */
.target-selector {
    max-width: 700px;
    margin: 0 auto 2rem;
}

.target-selector h3 {
    font-size: 1.1rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.25rem;
}

.target-subtitle {
    font-size: 0.85rem;
    color: #94a3b8 !important;
    margin: 0 auto 1rem !important;
}

.target-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.target-checkbox {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    background: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
}

.target-checkbox:hover {
    border-color: #93c5fd;
    background: #f0f9ff;
}

.target-checkbox.selected {
    border-color: #3b82f6;
    background: #eff6ff;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.target-checkbox input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #3b82f6;
    cursor: pointer;
    flex-shrink: 0;
}

.target-icon {
    font-size: 1.3rem;
    line-height: 1;
    flex-shrink: 0;
}

.target-info {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.target-label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #1e293b;
}

.target-desc {
    font-size: 0.75rem;
    color: #94a3b8;
    line-height: 1.3;
}

.target-badge {
    padding: 0.2rem 0.6rem;
    border-radius: 9999px;
    font-size: 0.7rem;
    font-weight: 600;
    background: #dbeafe;
    color: #1e40af;
    border: 1px solid #93c5fd;
    white-space: nowrap;
}

.tone-selector h3 {
    font-size: 1.1rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.25rem;
}

.tone-subtitle {
    font-size: 0.85rem;
    color: #94a3b8 !important;
    margin: 0 auto 1rem !important;
}

.tone-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.75rem;
}

@media (max-width: 640px) {
    .tone-cards {
        grid-template-columns: repeat(2, 1fr);
    }
}

.tone-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.35rem;
    padding: 0.9rem 0.5rem;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    background: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
}

.tone-card:hover {
    border-color: #93c5fd;
    background: #f0f9ff;
}

.tone-card.selected {
    border-color: #3b82f6;
    background: #eff6ff;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.tone-icon {
    font-size: 1.5rem;
    line-height: 1;
}

.tone-label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #1e293b;
}

.tone-desc {
    font-size: 0.7rem;
    color: #94a3b8;
    text-align: center;
    line-height: 1.3;
}

/* Platform Selector */
.platform-selector {
    max-width: 700px;
    margin: 0 auto 2rem;
}

.platform-selector h3 {
    font-size: 1.1rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.25rem;
}

.platform-subtitle {
    font-size: 0.85rem;
    color: #94a3b8 !important;
    margin: 0 auto 1rem !important;
}

.platform-toggles {
    display: flex;
    gap: 0.75rem;
    justify-content: center;
    flex-wrap: wrap;
}

.platform-toggle {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.25rem;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    background: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.9rem;
    font-weight: 500;
    color: #475569;
}

.platform-toggle:hover:not(.disabled) {
    border-color: #93c5fd;
    background: #f0f9ff;
}

.platform-toggle.selected {
    border-color: #3b82f6;
    background: #eff6ff;
    color: #1e40af;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.platform-toggle.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f8fafc;
}

.platform-toggle-icon {
    font-size: 1.2rem;
    line-height: 1;
}

.platform-toggle-label {
    font-weight: 600;
}

.platform-toggle-status {
    font-size: 0.75rem;
    margin-left: 0.25rem;
}

@media (max-width: 640px) {
    .platform-toggles {
        flex-direction: column;
    }

    .platform-toggle {
        justify-content: center;
    }
}

/* Posts Grid — Social Feed Style */
.posts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 1.25rem;
}

.post-card {
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
    display: flex;
    flex-direction: column;
}

.post-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.post-card.status-generating_audio,
.post-card.status-generating_video {
    border-color: #93c5fd;
}

.post-card.status-pending_validation {
    border-color: #fbbf24;
}

.post-card.status-published {
    border-color: #34d399;
}

/* Card Header — IG-style with avatar-like day badge */
.post-header {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #efefef;
    margin-bottom: 0;
}

.post-day-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 0.7rem;
    text-transform: uppercase;
    flex-shrink: 0;
}

.post-header-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.post-header-info h3 {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: #262626;
    line-height: 1.2;
}

.post-header-info .post-date-sub {
    font-size: 0.75rem;
    color: #8e8e8e;
    margin: 0;
}

.post-header-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.edited-badge {
    background: #e0e7ff;
    color: #4338ca;
    padding: 0.15rem 0.5rem;
    border-radius: 4px;
    font-size: 0.7rem;
    font-weight: 600;
}

.btn-header-download {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #475569;
    font-size: 0.9rem;
    text-decoration: none;
    transition: background 0.2s, color 0.2s;
}

.btn-header-download:hover {
    background: #e2e8f0;
    color: #1e293b;
}

/* Video / Media area — hero section */
.post-media-area {
    position: relative;
    background: #000;
    aspect-ratio: 9 / 16;
    max-height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.post-media-area .video-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 0;
    max-height: none;
}

.post-media-area .video-actions-overlay {
    position: absolute;
    bottom: 0.75rem;
    right: 0.75rem;
    display: flex;
    gap: 0.5rem;
}

.post-media-area .video-actions-overlay .btn {
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    padding: 0;
    backdrop-filter: blur(4px);
    transition: background 0.2s;
}

.post-media-area .video-actions-overlay .btn:hover {
    background: rgba(0, 0, 0, 0.75);
}

/* Script placeholder when no video yet */
.post-script-hero {
    position: relative;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1.5rem;
    overflow: visible;
}

.post-script-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 30% 70%, rgba(131, 58, 180, 0.15) 0%, transparent 60%),
        radial-gradient(circle at 80% 20%, rgba(253, 29, 29, 0.1) 0%, transparent 50%);
}

.post-script-hero .script-display {
    position: relative;
    z-index: 1;
    color: #fff;
    font-size: 0.95rem;
    line-height: 1.6;
    text-align: center;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.post-script-hero .script-icon {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    font-size: 1.5rem;
    opacity: 0.4;
}

/* Status overlay on media area */
.post-status-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    backdrop-filter: blur(2px);
}

.post-status-overlay .status-indicator {
    color: #fff;
    font-size: 0.9rem;
    margin: 0;
}

/* Card Body — IG-style caption area */
.post-body {
    padding: 0.75rem 1rem;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.post-body .caption-text {
    font-size: 0.88rem;
    color: #262626;
    line-height: 1.5;
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
}

.post-body .caption-text .caption-label {
    font-weight: 600;
    margin-right: 0.35rem;
}

.hashtags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    margin-top: 0;
}

.hashtag {
    background: transparent;
    color: #00376b;
    padding: 0;
    border-radius: 0;
    font-size: 0.85rem;
    font-weight: 500;
}

.hashtags .more {
    color: #8e8e8e;
    font-size: 0.82rem;
}

/* Card Footer — actions row */
.post-card-footer {
    padding: 0.5rem 1rem 0.75rem;
    border-top: 1px solid #efefef;
    display: flex;
    gap: 0.5rem;
}

.post-card-footer .btn {
    flex: 1 1;
    font-size: 0.82rem;
    padding: 0.45rem 0.5rem;
    text-align: center;
    justify-content: center;
}

/* Status section below caption */
.post-card .post-status-badge {
    margin: 0;
    padding: 0.4rem 0.75rem;
    border-radius: 0;
    border-top: 1px solid #efefef;
    text-align: center;
    font-size: 0.82rem;
}

.post-card .post-status-badge.approved {
    background: rgba(34, 197, 94, 0.06);
}

.post-card .post-status-badge.queued {
    background: rgba(59, 130, 246, 0.06);
}

.post-card .post-status-badge.rejected {
    background: rgba(220, 53, 69, 0.04);
}

/* Failed actions inside card */
.post-card .post-failed-actions {
    margin: 0;
    padding: 0.5rem 1rem;
    border-radius: 0;
    border-top: 1px solid #efefef;
    border-bottom: none;
}

@media (max-width: 720px) {
    .posts-grid {
        grid-template-columns: 1fr;
        max-width: 400px;
        margin: 0 auto;
    }
}

.status-indicator {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1rem;
    color: #3b82f6;
    font-size: 0.9rem;
}

/* Spinner */
.spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid #93c5fd;
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.spinner.large {
    width: 40px;
    height: 40px;
    border-width: 3px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Edit Form */
.edit-form .form-group {
    margin-bottom: 1rem;
}

.edit-form .form-group label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.25rem;
    font-size: 0.85rem;
}

.edit-form textarea,
.edit-form input[type='text'] {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-family: inherit;
    font-size: 0.9rem;
    resize: vertical;
}

.edit-form textarea:focus,
.edit-form input[type='text']:focus {
    outline: none;
    border-color: #4f46e5;
    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);
}

.form-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
}

/* Confirm Section */
.confirm-section {
    text-align: center;
    margin-top: 2rem;
    padding: 2rem;
    background: #f8fafc;
    border-radius: 12px;
}

.confirm-note {
    color: #64748b;
    margin-bottom: 1rem;
    font-size: 0.9rem;
}

/* Buttons */
.btn {
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.2s;
    font-size: 0.9rem;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-primary {
    background: #4f46e5;
    color: white;
}

.btn-primary:hover:not(:disabled) {
    background: #4338ca;
}

.btn-secondary {
    background: #f1f5f9;
    color: #334155;
}

.btn-secondary:hover:not(:disabled) {
    background: #e2e8f0;
}

.btn-danger {
    background: #fee2e2;
    color: #dc2626;
    border: 1px solid #fca5a5;
}

.btn-danger:hover:not(:disabled) {
    background: #fecaca;
    color: #b91c1c;
}

.btn-large {
    padding: 0.75rem 2rem;
    font-size: 1rem;
}

/* Regenerate Buttons */
.batch-actions {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.btn-delete-batch {
    background: transparent;
    color: #dc2626;
    border: 1.5px solid #dc2626 !important;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1.25rem;
    font-size: 0.85rem;
    white-space: nowrap;
}

.btn-delete-batch:hover:not(:disabled) {
    background: #fef2f2;
    color: #b91c1c;
    border-color: #b91c1c !important;
}

.btn-regenerate-all {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1.25rem;
    font-size: 0.85rem;
    white-space: nowrap;
}

.btn-regenerate-all:hover:not(:disabled) {
    background: linear-gradient(135deg, #d97706, #b45309);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(217, 119, 6, 0.3);
}

.btn-regenerate-all i {
    font-size: 1rem;
}

.btn-regenerate {
    background: transparent;
    color: #d97706;
    border: 1.5px solid #d97706 !important;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.35rem 0.75rem;
    font-size: 0.8rem;
}

.btn-regenerate:hover:not(:disabled) {
    background: #fffbeb;
    color: #b45309;
    border-color: #b45309 !important;
}

.btn-regenerate i {
    font-size: 0.85rem;
}

.post-actions-row {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.75rem;
    flex-wrap: wrap;
}

.post-actions-row .btn,
.post-card-footer .btn {
    flex: 1 1;
    min-width: 0;
    text-align: center;
    justify-content: center;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
}

/* Regenerating status indicator on post card */
.post-card .status-indicator .spinner.small {
    width: 14px;
    height: 14px;
    border-width: 2px;
}

.spinner.small {
    width: 14px;
    height: 14px;
    border-width: 2px;
    display: inline-block;
    vertical-align: middle;
}

/* ── Post Failed Actions (retry video per post) ── */

.post-failed-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    margin-top: 0.75rem;
    padding: 0.5rem 0.75rem;
    background: rgba(220, 53, 69, 0.08);
    border-radius: 8px;
    border: 1px solid rgba(220, 53, 69, 0.2);
}

.post-failed-actions .error-message {
    font-size: 0.85rem;
    color: #dc3545;
    font-weight: 500;
}

.btn-retry {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0.85rem;
    font-size: 0.82rem;
    font-weight: 600;
    background: #dc3545;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.2s;
}

.btn-retry:hover {
    background: #bb2d3b;
}

.btn-retry:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* ── Video Preview (legacy — kept for scheduled tab) ── */

.post-video-preview {
    margin-top: 0.75rem;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
}

.video-player {
    width: 100%;
    max-height: 400px;
    display: block;
    background: #000;
}

/* ── Video Actions ── */

.post-video-actions {
    display: flex;
    gap: 0.75rem;
    padding: 0.5rem 0;
    justify-content: flex-end;
}

.btn-download-video {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
    font-weight: 600;
    background: #3b82f6;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    text-decoration: none;
    transition: background 0.2s;
}

.btn-download-video:hover {
    background: #2563eb;
    color: #fff;
}

/* ── Post Status Badges ── */

.post-status-badge {
    margin-top: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    font-size: 0.85rem;
    font-weight: 600;
    text-align: center;
}

.post-status-badge.approved {
    background: rgba(34, 197, 94, 0.1);
    color: #16a34a;
    border: 1px solid rgba(34, 197, 94, 0.2);
}

.post-status-badge.queued {
    background: rgba(59, 130, 246, 0.1);
    color: #2563eb;
    border: 1px solid rgba(59, 130, 246, 0.2);
}

.post-status-badge.queued .publish-time {
    font-weight: 400;
    font-size: 0.8rem;
}

.post-status-badge.rejected {
    background: rgba(220, 53, 69, 0.08);
    color: #dc3545;
    border: 1px solid rgba(220, 53, 69, 0.2);
}

/* Orphan-approved badge: post is approved but no publication slot was
   available. Surfaced alongside the green "approved" badge so the user
   sees both states at once. */
.post-status-badge.orphan {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(245, 158, 11, 0.1);
    color: #b45309;
    border: 1px solid rgba(245, 158, 11, 0.25);
    flex-wrap: wrap;
}

.post-status-badge.orphan .btn-retry-scheduling {
    border: 1px solid currentColor;
    background: transparent;
    color: inherit;
    padding: 0.15rem 0.5rem;
    border-radius: 6px;
    font-size: 0.8rem;
    cursor: pointer;
}

.post-status-badge.orphan .btn-retry-scheduling:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Highlight card based on post status */
.post-card.status-pending_validation {
    border-color: #22c55e;
    box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.2);
}

.post-card.status-approved,
.post-card.status-queued {
    border-color: #3b82f6;
}

.post-card.status-rejected {
    border-color: #dc3545;
    opacity: 0.7;
}

/* ── Generation Progress Banner (non-blocking) ── */

.generation-banner {
    position: sticky;
    top: 0;
    z-index: 100;
    background: linear-gradient(135deg, #f8faff 0%, #f0f4ff 100%);
    border: 1px solid #c7d2fe;
    border-radius: 12px;
    padding: 1.25rem 1.5rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 12px rgba(99, 102, 241, 0.1);
    animation: banner-slide-in 0.4s ease;
}

@keyframes banner-slide-in {
    from {
        opacity: 0;
        transform: translateY(-12px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.generation-banner-header {
    margin-bottom: 0.75rem;
}

.generation-banner-title {
    display: flex;
    align-items: center;
    gap: 0.6rem;
}

.generation-banner-title h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #1e293b;
}

.generation-banner-subtitle {
    margin: 0.25rem 0 0;
    font-size: 0.85rem;
    color: #64748b;
}

/* ── Generation Progress ── */

.generation-progress {
    margin-top: 1.5rem;
    text-align: left;
}

.progress-bar-container {
    width: 100%;
    height: 8px;
    background: #e2e8f0;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 0.75rem;
}

.progress-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #6366f1, #8b5cf6);
    border-radius: 4px;
    transition: width 0.6s ease;
    min-width: 2%;
}

.progress-stats {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 0.85rem;
    color: #475569;
    margin-bottom: 1rem;
}

.progress-stats span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.progress-failed {
    color: #ef4444 !important;
    font-weight: 600;
}

.progress-posts-detail {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 0.5rem;
}

.progress-post-item {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.4rem 0.6rem;
    border-radius: 8px;
    background: #f8fafc;
    font-size: 0.8rem;
    border: 1px solid #e2e8f0;
    transition: background 0.3s, border-color 0.3s;
}

.progress-post-item.status-generating_audio,
.progress-post-item.status-generating_video {
    background: #eef2ff;
    border-color: #c7d2fe;
}

.progress-post-item.status-pending_validation {
    background: #f0fdf4;
    border-color: #bbf7d0;
}

.progress-post-item.status-audio_failed,
.progress-post-item.status-video_failed,
.progress-post-item.status-failed {
    background: #fef2f2;
    border-color: #fecaca;
}

.day-label {
    font-weight: 600;
    min-width: 30px;
}

.post-status-text {
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Skeleton Loading ── */

@keyframes skeleton-shimmer {
    0% {
        background-position: -400px 0;
    }

    100% {
        background-position: 400px 0;
    }
}

.skeleton-line {
    background: linear-gradient(90deg,
            #e2e8f0 25%,
            #f1f5f9 50%,
            #e2e8f0 75%);
    background-size: 800px 100%;
    animation: skeleton-shimmer 1.8s ease-in-out infinite;
    border-radius: 6px;
}

.skeleton-post-card {
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    animation: skeleton-fade-in 0.4s ease both;
}

@keyframes skeleton-fade-in {
    from {
        opacity: 0;
        transform: translateY(8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.skeleton-post-card .skeleton-card-header {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #efefef;
}

.skeleton-post-card .skeleton-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex-shrink: 0;
}

.skeleton-post-card .skeleton-header-text {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    flex: 1 1;
}

.skeleton-post-card .skeleton-header {
    height: 14px;
    width: 45%;
}

.skeleton-post-card .skeleton-sub {
    height: 10px;
    width: 30%;
}

.skeleton-post-card .skeleton-media {
    width: 100%;
    aspect-ratio: 9 / 16;
    max-height: 420px;
    border-radius: 0;
}

.skeleton-post-card .skeleton-caption-area {
    padding: 0.75rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.skeleton-post-card .skeleton-label {
    height: 10px;
    width: 25%;
    margin-bottom: 0.25rem;
}

.skeleton-post-card .skeleton-text-long {
    height: 14px;
    width: 100%;
}

.skeleton-post-card .skeleton-text-medium {
    height: 14px;
    width: 75%;
}

.skeleton-post-card .skeleton-text-short {
    height: 14px;
    width: 50%;
}

.skeleton-post-card .skeleton-tags {
    display: flex;
    gap: 0.375rem;
    margin-top: 0.25rem;
}

.skeleton-post-card .skeleton-tag {
    height: 18px;
    width: 65px;
    border-radius: 4px;
}

.skeleton-post-card .skeleton-btn-row {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem 1rem 0.75rem;
    border-top: 1px solid #efefef;
}

.skeleton-post-card .skeleton-btn {
    height: 34px;
    flex: 1 1;
    border-radius: 8px;
}

.skeleton-generating-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1.5rem;
    padding: 1rem 1.25rem;
    background: linear-gradient(135deg, #f8faff 0%, #f0f4ff 100%);
    border: 1px solid #c7d2fe;
    border-radius: 12px;
    animation: banner-slide-in 0.4s ease;
}

.skeleton-generating-header .skeleton-gen-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.skeleton-generating-header .skeleton-gen-title {
    display: flex;
    align-items: center;
    gap: 0.6rem;
}

.skeleton-generating-header .skeleton-gen-title h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #1e293b;
}

.skeleton-generating-header .skeleton-gen-subtitle {
    font-size: 0.85rem;
    color: #64748b;
    margin: 0;
}

/* ═══════════ Mobile: Post Cards & Actions ═══════════ */

@media (max-width: 640px) {
    .scheduled-post-actions {
        flex-wrap: wrap;
        gap: 0.4rem;
    }

    .scheduled-post-actions button {
        font-size: 0.72rem;
        padding: 0.3rem 0.55rem;
    }

    .post-card-footer {
        flex-wrap: wrap;
        gap: 0.4rem;
    }
}

@media (max-width: 380px) {
    .scheduled-post-actions button {
        font-size: 0.68rem;
        padding: 0.25rem 0.45rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/WeeklyPostGenerator.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA,yBAAyB;;AAEzB;IACI,aAAa;IACb,MAAM;IACN,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qDAAqD;AACzD;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,aAAa,EAAE;AACzB;;AAEA;;+CAE+C;AAC/C;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,sDAAsD;AAC1D;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,kEAAkE;AAClE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,4DAA4D;IAC5D,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,sDAAsD;AACtD;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8DAA8D;IAC9D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,UAAU;IACV,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,0EAA0E;IAC1E,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;sFACkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAS;AACb;;AAEA,sCAAsC;AACtC;IACI,qBAAqB;IACrB,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,iCAAiC;AACjC;IACI,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,+BAA+B;AAC/B;IACI,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,cAAc;AACd;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,sCAAsC;IACtC,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,+CAA+C;AAC/C;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,qDAAqD;;AAErD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,0DAA0D;;AAE1D;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,6BAA6B;;AAE7B;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;;8BAE8B;AAC9B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,mCAAmC;IACnC,cAAc;IACd,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA,oDAAoD;;AAEpD;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,8CAA8C;IAC9C,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,8BAA8B;;AAE9B;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;;IAGI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,2BAA2B;;AAE3B;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;;;wBAGoB;IACpB,2BAA2B;IAC3B,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAO;AACX;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,qBAAqB;IACrB,qBAAqB;IACrB,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA,yDAAyD;;AAEzD;IACI;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,wBAAwB;IAC5B;AACJ","sourcesContent":["/* WeeklyPostGenerator Styles */\n\n.weekly-posts-page {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 2rem;\n}\n\n/* ── Tab Navigation ── */\n\n.posts-tabs {\n    display: flex;\n    gap: 0;\n    border-bottom: 2px solid #e2e8f0;\n    margin-bottom: 2rem;\n}\n\n.posts-tab-btn {\n    position: relative;\n    padding: 0.75rem 1.5rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #94a3b8;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    transition: color 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    white-space: nowrap;\n}\n\n.posts-tab-btn:hover {\n    color: #475569;\n}\n\n.posts-tab-btn.active {\n    color: #4f46e5;\n}\n\n.posts-tab-btn.active::after {\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: #4f46e5;\n    border-radius: 2px 2px 0 0;\n}\n\n.posts-tab-btn .tab-icon {\n    font-size: 1.1rem;\n}\n\n.posts-tab-btn .tab-count {\n    background: #e0e7ff;\n    color: #4338ca;\n    padding: 0.1rem 0.5rem;\n    border-radius: 9999px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    min-width: 20px;\n    text-align: center;\n}\n\n/* ── Scheduled Posts Tab ── */\n\n.scheduled-posts-section {\n    margin-top: 0;\n}\n\n.scheduled-posts-filters {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-bottom: 1.5rem;\n}\n\n.filter-btn {\n    padding: 0.4rem 1rem;\n    font-size: 0.82rem;\n    font-weight: 600;\n    border: 1.5px solid #e2e8f0;\n    border-radius: 9999px;\n    background: #fff;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.filter-btn:hover {\n    border-color: #93c5fd;\n    color: #3b82f6;\n}\n\n.filter-btn.active {\n    background: #4f46e5;\n    color: #fff;\n    border-color: #4f46e5;\n}\n\n.scheduled-posts-empty {\n    text-align: center;\n    padding: 3rem 1rem;\n    color: #94a3b8;\n}\n\n.scheduled-posts-empty .empty-icon {\n    font-size: 3rem;\n    margin-bottom: 0.75rem;\n}\n\n.scheduled-posts-empty p {\n    font-size: 1rem;\n    margin: 0;\n}\n\n.scheduled-post-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 1.25rem 1.5rem;\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: flex-start;\n    gap: 1.25rem;\n    transition: box-shadow 0.2s;\n}\n\n.scheduled-post-card:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.scheduled-post-date {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 60px;\n    padding: 0.5rem 0.75rem;\n    background: #f1f5f9;\n    border-radius: 10px;\n    flex-shrink: 0;\n}\n\n.scheduled-post-date .date-day {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: #1e293b;\n    line-height: 1;\n}\n\n.scheduled-post-date .date-month {\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    margin-top: 0.15rem;\n}\n\n.scheduled-post-body {\n    flex: 1;\n    min-width: 0;\n}\n\n.scheduled-post-body .post-meta {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.scheduled-post-body .caption-text {\n    font-size: 0.9rem;\n    color: #334155;\n    line-height: 1.5;\n    margin: 0 0 0.5rem 0;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.scheduled-post-body .hashtags {\n    margin-top: 0.25rem;\n}\n\n.scheduled-post-actions {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.5rem;\n}\n\n.scheduled-post-card .platform-icons {\n    display: flex;\n    gap: 0.35rem;\n    font-size: 1rem;\n}\n\n.status-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    padding: 0.2rem 0.65rem;\n    border-radius: 9999px;\n    font-size: 0.75rem;\n    font-weight: 600;\n}\n\n.status-pill.pill-approved {\n    background: rgba(34, 197, 94, 0.1);\n    color: #16a34a;\n}\n\n.status-pill.pill-queued {\n    background: rgba(59, 130, 246, 0.1);\n    color: #2563eb;\n}\n\n.status-pill.pill-published {\n    background: rgba(16, 185, 129, 0.1);\n    color: #059669;\n}\n\n.status-pill.pill-publishing {\n    background: rgba(99, 102, 241, 0.12);\n    color: #4338ca;\n    animation: publishing-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes publishing-pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.55; }\n}\n\n/* Publish-Now banner — shown above the scheduled-posts list while a\n   post is being promoted to immediate publication, and remains visible\n   until the worker reaches a terminal state. */\n.publish-notification {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 1rem;\n    border-radius: 10px;\n    margin-bottom: 1rem;\n    font-size: 0.92rem;\n    font-weight: 500;\n    border: 1px solid transparent;\n    animation: publish-notification-fade-in 0.25s ease-out;\n}\n\n@keyframes publish-notification-fade-in {\n    from { opacity: 0; transform: translateY(-4px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.publish-notification-icon {\n    font-size: 1.1rem;\n    flex-shrink: 0;\n}\n\n.publish-notification-message {\n    flex: 1;\n    line-height: 1.4;\n}\n\n.publish-notification-close {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 1.25rem;\n    line-height: 1;\n    padding: 0 0.25rem;\n    color: inherit;\n    opacity: 0.6;\n    flex-shrink: 0;\n}\n\n.publish-notification-close:hover {\n    opacity: 1;\n}\n\n.publish-notification-info {\n    background: rgba(99, 102, 241, 0.1);\n    color: #4338ca;\n    border-color: rgba(99, 102, 241, 0.25);\n}\n\n.publish-notification-success {\n    background: #d1fae5;\n    color: #065f46;\n    border-color: #6ee7b7;\n}\n\n.publish-notification-partial {\n    background: rgba(251, 146, 60, 0.12);\n    color: #c2410c;\n    border-color: rgba(251, 146, 60, 0.35);\n}\n\n.publish-notification-error {\n    background: #fee2e2;\n    color: #991b1b;\n    border-color: #fca5a5;\n}\n\n.status-pill.pill-rejected {\n    background: rgba(220, 53, 69, 0.08);\n    color: #dc3545;\n}\n\n.status-pill.pill-failed {\n    background: rgba(220, 53, 69, 0.08);\n    color: #dc3545;\n}\n\n.status-pill.pill-pending_validation {\n    background: rgba(251, 191, 36, 0.1);\n    color: #d97706;\n}\n\n.status-pill.pill-generating {\n    background: rgba(99, 102, 241, 0.1);\n    color: #6366f1;\n}\n\n.status-pill.pill-draft {\n    background: #f1f5f9;\n    color: #64748b;\n}\n\n.status-pill.pill-partially_published {\n    background: rgba(251, 146, 60, 0.12);\n    color: #c2410c;\n}\n\n/* ── Platform icon badges (per-platform status on post card) ── */\n.platform-icon-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    font-size: 1rem;\n    transition: opacity 0.2s;\n}\n\n.platform-icon-badge.platform-ok::after {\n    content: '✓';\n    position: absolute;\n    bottom: -2px;\n    right: -4px;\n    font-size: 0.55rem;\n    font-weight: 700;\n    color: #16a34a;\n    background: #dcfce7;\n    border-radius: 50%;\n    width: 12px;\n    height: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.platform-icon-badge.platform-fail {\n    opacity: 0.6;\n}\n\n.platform-icon-badge.platform-fail::after {\n    content: '✗';\n    position: absolute;\n    bottom: -2px;\n    right: -4px;\n    font-size: 0.55rem;\n    font-weight: 700;\n    color: #dc2626;\n    background: #fee2e2;\n    border-radius: 50%;\n    width: 12px;\n    height: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n/* ── Per-platform error detail rows ── */\n.platform-results-detail {\n    margin-top: 0.6rem;\n    padding: 0.6rem 0.75rem;\n    background: #fafafa;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.platform-result-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.8rem;\n    line-height: 1.4;\n}\n\n.platform-result-icon {\n    font-size: 0.95rem;\n    flex-shrink: 0;\n}\n\n.platform-result-name {\n    font-weight: 600;\n    color: #334155;\n    min-width: 70px;\n    flex-shrink: 0;\n}\n\n.platform-result-status {\n    flex: 1;\n    min-width: 0;\n}\n\n.platform-result-status.ok {\n    color: #16a34a;\n    font-weight: 500;\n}\n\n.platform-result-status.error {\n    color: #dc2626;\n    word-break: break-word;\n}\n\n.platform-result-row.result-ok {\n    opacity: 0.75;\n}\n\n.platform-result-row.result-error {\n    background: rgba(220, 38, 38, 0.04);\n    padding: 0.3rem 0.5rem;\n    border-radius: 6px;\n    margin: 0 -0.25rem;\n}\n\n@media (max-width: 640px) {\n    .scheduled-post-card {\n        flex-direction: column;\n        gap: 0.75rem;\n    }\n\n    .scheduled-post-date {\n        flex-direction: row;\n        gap: 0.5rem;\n        min-width: unset;\n    }\n\n    .posts-tabs {\n        overflow-x: auto;\n    }\n}\n\n.page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n}\n\n.batch-info {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.week-label {\n    font-size: 1rem;\n    color: #64748b;\n}\n\n.tone-badge {\n    padding: 0.25rem 0.75rem;\n    border-radius: 9999px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    background: #fef3c7;\n    color: #92400e;\n    border: 1px solid #fcd34d;\n}\n\n.status-badge {\n    padding: 0.25rem 0.75rem;\n    border-radius: 9999px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.status-badge.status-draft {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.status-badge.status-confirmed,\n.status-badge.status-generating {\n    background: #dbeafe;\n    color: #1e40af;\n}\n\n.status-badge.status-completed {\n    background: #d1fae5;\n    color: #065f46;\n}\n\n.status-badge.status-failed {\n    background: #fee2e2;\n    color: #991b1b;\n}\n\n/* Prerequisites */\n.prerequisites-warning {\n    background: #fffbeb;\n    border: 1px solid #fbbf24;\n    border-radius: 12px;\n    padding: 2rem;\n    margin-top: 1rem;\n}\n\n.prereq-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 0;\n}\n\n.prereq-item.missing {\n    color: #dc2626;\n}\n\n/* Generate Section */\n.generate-section {\n    text-align: center;\n    padding: 4rem 2rem;\n}\n\n.generate-section p {\n    color: #64748b;\n    max-width: 480px;\n    margin: 1rem auto 2rem;\n    line-height: 1.6;\n}\n\n/* Tone Selector */\n.tone-selector {\n    max-width: 700px;\n    margin: 0 auto 2rem;\n}\n\n/* Target Audience Selector */\n.target-selector {\n    max-width: 700px;\n    margin: 0 auto 2rem;\n}\n\n.target-selector h3 {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 0.25rem;\n}\n\n.target-subtitle {\n    font-size: 0.85rem;\n    color: #94a3b8 !important;\n    margin: 0 auto 1rem !important;\n}\n\n.target-checkboxes {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n}\n\n.target-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 1rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 12px;\n    background: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.target-checkbox:hover {\n    border-color: #93c5fd;\n    background: #f0f9ff;\n}\n\n.target-checkbox.selected {\n    border-color: #3b82f6;\n    background: #eff6ff;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.target-checkbox input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    accent-color: #3b82f6;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.target-icon {\n    font-size: 1.3rem;\n    line-height: 1;\n    flex-shrink: 0;\n}\n\n.target-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.1rem;\n}\n\n.target-label {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.target-desc {\n    font-size: 0.75rem;\n    color: #94a3b8;\n    line-height: 1.3;\n}\n\n.target-badge {\n    padding: 0.2rem 0.6rem;\n    border-radius: 9999px;\n    font-size: 0.7rem;\n    font-weight: 600;\n    background: #dbeafe;\n    color: #1e40af;\n    border: 1px solid #93c5fd;\n    white-space: nowrap;\n}\n\n.tone-selector h3 {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 0.25rem;\n}\n\n.tone-subtitle {\n    font-size: 0.85rem;\n    color: #94a3b8 !important;\n    margin: 0 auto 1rem !important;\n}\n\n.tone-cards {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.75rem;\n}\n\n@media (max-width: 640px) {\n    .tone-cards {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n.tone-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.9rem 0.5rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 12px;\n    background: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.tone-card:hover {\n    border-color: #93c5fd;\n    background: #f0f9ff;\n}\n\n.tone-card.selected {\n    border-color: #3b82f6;\n    background: #eff6ff;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.tone-icon {\n    font-size: 1.5rem;\n    line-height: 1;\n}\n\n.tone-label {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.tone-desc {\n    font-size: 0.7rem;\n    color: #94a3b8;\n    text-align: center;\n    line-height: 1.3;\n}\n\n/* Platform Selector */\n.platform-selector {\n    max-width: 700px;\n    margin: 0 auto 2rem;\n}\n\n.platform-selector h3 {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 0.25rem;\n}\n\n.platform-subtitle {\n    font-size: 0.85rem;\n    color: #94a3b8 !important;\n    margin: 0 auto 1rem !important;\n}\n\n.platform-toggles {\n    display: flex;\n    gap: 0.75rem;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.platform-toggle {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.25rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 12px;\n    background: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: #475569;\n}\n\n.platform-toggle:hover:not(.disabled) {\n    border-color: #93c5fd;\n    background: #f0f9ff;\n}\n\n.platform-toggle.selected {\n    border-color: #3b82f6;\n    background: #eff6ff;\n    color: #1e40af;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.platform-toggle.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background: #f8fafc;\n}\n\n.platform-toggle-icon {\n    font-size: 1.2rem;\n    line-height: 1;\n}\n\n.platform-toggle-label {\n    font-weight: 600;\n}\n\n.platform-toggle-status {\n    font-size: 0.75rem;\n    margin-left: 0.25rem;\n}\n\n@media (max-width: 640px) {\n    .platform-toggles {\n        flex-direction: column;\n    }\n\n    .platform-toggle {\n        justify-content: center;\n    }\n}\n\n/* Posts Grid — Social Feed Style */\n.posts-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n    gap: 1.25rem;\n}\n\n.post-card {\n    background: #ffffff;\n    border: 1px solid #dbdbdb;\n    border-radius: 8px;\n    overflow: hidden;\n    transition: transform 0.2s, box-shadow 0.2s;\n    display: flex;\n    flex-direction: column;\n}\n\n.post-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n}\n\n.post-card.status-generating_audio,\n.post-card.status-generating_video {\n    border-color: #93c5fd;\n}\n\n.post-card.status-pending_validation {\n    border-color: #fbbf24;\n}\n\n.post-card.status-published {\n    border-color: #34d399;\n}\n\n/* Card Header — IG-style with avatar-like day badge */\n.post-header {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid #efefef;\n    margin-bottom: 0;\n}\n\n.post-day-avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-weight: 700;\n    font-size: 0.7rem;\n    text-transform: uppercase;\n    flex-shrink: 0;\n}\n\n.post-header-info {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.post-header-info h3 {\n    margin: 0;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #262626;\n    line-height: 1.2;\n}\n\n.post-header-info .post-date-sub {\n    font-size: 0.75rem;\n    color: #8e8e8e;\n    margin: 0;\n}\n\n.post-header-right {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.edited-badge {\n    background: #e0e7ff;\n    color: #4338ca;\n    padding: 0.15rem 0.5rem;\n    border-radius: 4px;\n    font-size: 0.7rem;\n    font-weight: 600;\n}\n\n.btn-header-download {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: #f1f5f9;\n    color: #475569;\n    font-size: 0.9rem;\n    text-decoration: none;\n    transition: background 0.2s, color 0.2s;\n}\n\n.btn-header-download:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n/* Video / Media area — hero section */\n.post-media-area {\n    position: relative;\n    background: #000;\n    aspect-ratio: 9 / 16;\n    max-height: 420px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.post-media-area .video-player {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    border-radius: 0;\n    max-height: none;\n}\n\n.post-media-area .video-actions-overlay {\n    position: absolute;\n    bottom: 0.75rem;\n    right: 0.75rem;\n    display: flex;\n    gap: 0.5rem;\n}\n\n.post-media-area .video-actions-overlay .btn {\n    background: rgba(0, 0, 0, 0.55);\n    color: #fff;\n    border: none;\n    border-radius: 50%;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.9rem;\n    padding: 0;\n    backdrop-filter: blur(4px);\n    transition: background 0.2s;\n}\n\n.post-media-area .video-actions-overlay .btn:hover {\n    background: rgba(0, 0, 0, 0.75);\n}\n\n/* Script placeholder when no video yet */\n.post-script-hero {\n    position: relative;\n    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n    min-height: 120px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem 1.5rem;\n    overflow: visible;\n}\n\n.post-script-hero::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: radial-gradient(circle at 30% 70%, rgba(131, 58, 180, 0.15) 0%, transparent 60%),\n        radial-gradient(circle at 80% 20%, rgba(253, 29, 29, 0.1) 0%, transparent 50%);\n}\n\n.post-script-hero .script-display {\n    position: relative;\n    z-index: 1;\n    color: #fff;\n    font-size: 0.95rem;\n    line-height: 1.6;\n    text-align: center;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.post-script-hero .script-icon {\n    position: absolute;\n    bottom: 1rem;\n    right: 1rem;\n    font-size: 1.5rem;\n    opacity: 0.4;\n}\n\n/* Status overlay on media area */\n.post-status-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    backdrop-filter: blur(2px);\n}\n\n.post-status-overlay .status-indicator {\n    color: #fff;\n    font-size: 0.9rem;\n    margin: 0;\n}\n\n/* Card Body — IG-style caption area */\n.post-body {\n    padding: 0.75rem 1rem;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.post-body .caption-text {\n    font-size: 0.88rem;\n    color: #262626;\n    line-height: 1.5;\n    margin: 0;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.post-body .caption-text .caption-label {\n    font-weight: 600;\n    margin-right: 0.35rem;\n}\n\n.hashtags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.3rem;\n    margin-top: 0;\n}\n\n.hashtag {\n    background: transparent;\n    color: #00376b;\n    padding: 0;\n    border-radius: 0;\n    font-size: 0.85rem;\n    font-weight: 500;\n}\n\n.hashtags .more {\n    color: #8e8e8e;\n    font-size: 0.82rem;\n}\n\n/* Card Footer — actions row */\n.post-card-footer {\n    padding: 0.5rem 1rem 0.75rem;\n    border-top: 1px solid #efefef;\n    display: flex;\n    gap: 0.5rem;\n}\n\n.post-card-footer .btn {\n    flex: 1;\n    font-size: 0.82rem;\n    padding: 0.45rem 0.5rem;\n    text-align: center;\n    justify-content: center;\n}\n\n/* Status section below caption */\n.post-card .post-status-badge {\n    margin: 0;\n    padding: 0.4rem 0.75rem;\n    border-radius: 0;\n    border-top: 1px solid #efefef;\n    text-align: center;\n    font-size: 0.82rem;\n}\n\n.post-card .post-status-badge.approved {\n    background: rgba(34, 197, 94, 0.06);\n}\n\n.post-card .post-status-badge.queued {\n    background: rgba(59, 130, 246, 0.06);\n}\n\n.post-card .post-status-badge.rejected {\n    background: rgba(220, 53, 69, 0.04);\n}\n\n/* Failed actions inside card */\n.post-card .post-failed-actions {\n    margin: 0;\n    padding: 0.5rem 1rem;\n    border-radius: 0;\n    border-top: 1px solid #efefef;\n    border-bottom: none;\n}\n\n@media (max-width: 720px) {\n    .posts-grid {\n        grid-template-columns: 1fr;\n        max-width: 400px;\n        margin: 0 auto;\n    }\n}\n\n.status-indicator {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 1rem;\n    color: #3b82f6;\n    font-size: 0.9rem;\n}\n\n/* Spinner */\n.spinner {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border: 2px solid #93c5fd;\n    border-top-color: #3b82f6;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n.spinner.large {\n    width: 40px;\n    height: 40px;\n    border-width: 3px;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Edit Form */\n.edit-form .form-group {\n    margin-bottom: 1rem;\n}\n\n.edit-form .form-group label {\n    display: block;\n    font-weight: 600;\n    margin-bottom: 0.25rem;\n    font-size: 0.85rem;\n}\n\n.edit-form textarea,\n.edit-form input[type='text'] {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-family: inherit;\n    font-size: 0.9rem;\n    resize: vertical;\n}\n\n.edit-form textarea:focus,\n.edit-form input[type='text']:focus {\n    outline: none;\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.15);\n}\n\n.form-actions {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: flex-end;\n}\n\n/* Confirm Section */\n.confirm-section {\n    text-align: center;\n    margin-top: 2rem;\n    padding: 2rem;\n    background: #f8fafc;\n    border-radius: 12px;\n}\n\n.confirm-note {\n    color: #64748b;\n    margin-bottom: 1rem;\n    font-size: 0.9rem;\n}\n\n/* Buttons */\n.btn {\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s;\n    font-size: 0.9rem;\n}\n\n.btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.btn-primary {\n    background: #4f46e5;\n    color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n    background: #4338ca;\n}\n\n.btn-secondary {\n    background: #f1f5f9;\n    color: #334155;\n}\n\n.btn-secondary:hover:not(:disabled) {\n    background: #e2e8f0;\n}\n\n.btn-danger {\n    background: #fee2e2;\n    color: #dc2626;\n    border: 1px solid #fca5a5;\n}\n\n.btn-danger:hover:not(:disabled) {\n    background: #fecaca;\n    color: #b91c1c;\n}\n\n.btn-large {\n    padding: 0.75rem 2rem;\n    font-size: 1rem;\n}\n\n/* Regenerate Buttons */\n.batch-actions {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.btn-delete-batch {\n    background: transparent;\n    color: #dc2626;\n    border: 1.5px solid #dc2626 !important;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1.25rem;\n    font-size: 0.85rem;\n    white-space: nowrap;\n}\n\n.btn-delete-batch:hover:not(:disabled) {\n    background: #fef2f2;\n    color: #b91c1c;\n    border-color: #b91c1c !important;\n}\n\n.btn-regenerate-all {\n    background: linear-gradient(135deg, #f59e0b, #d97706);\n    color: white;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1.25rem;\n    font-size: 0.85rem;\n    white-space: nowrap;\n}\n\n.btn-regenerate-all:hover:not(:disabled) {\n    background: linear-gradient(135deg, #d97706, #b45309);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(217, 119, 6, 0.3);\n}\n\n.btn-regenerate-all i {\n    font-size: 1rem;\n}\n\n.btn-regenerate {\n    background: transparent;\n    color: #d97706;\n    border: 1.5px solid #d97706 !important;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.35rem 0.75rem;\n    font-size: 0.8rem;\n}\n\n.btn-regenerate:hover:not(:disabled) {\n    background: #fffbeb;\n    color: #b45309;\n    border-color: #b45309 !important;\n}\n\n.btn-regenerate i {\n    font-size: 0.85rem;\n}\n\n.post-actions-row {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.75rem;\n    flex-wrap: wrap;\n}\n\n.post-actions-row .btn,\n.post-card-footer .btn {\n    flex: 1;\n    min-width: 0;\n    text-align: center;\n    justify-content: center;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n}\n\n/* Regenerating status indicator on post card */\n.post-card .status-indicator .spinner.small {\n    width: 14px;\n    height: 14px;\n    border-width: 2px;\n}\n\n.spinner.small {\n    width: 14px;\n    height: 14px;\n    border-width: 2px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n/* ── Post Failed Actions (retry video per post) ── */\n\n.post-failed-actions {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    margin-top: 0.75rem;\n    padding: 0.5rem 0.75rem;\n    background: rgba(220, 53, 69, 0.08);\n    border-radius: 8px;\n    border: 1px solid rgba(220, 53, 69, 0.2);\n}\n\n.post-failed-actions .error-message {\n    font-size: 0.85rem;\n    color: #dc3545;\n    font-weight: 500;\n}\n\n.btn-retry {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.4rem 0.85rem;\n    font-size: 0.82rem;\n    font-weight: 600;\n    background: #dc3545;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.2s;\n}\n\n.btn-retry:hover {\n    background: #bb2d3b;\n}\n\n.btn-retry:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* ── Video Preview (legacy — kept for scheduled tab) ── */\n\n.post-video-preview {\n    margin-top: 0.75rem;\n    border-radius: 10px;\n    overflow: hidden;\n    border: 1px solid #e2e8f0;\n}\n\n.video-player {\n    width: 100%;\n    max-height: 400px;\n    display: block;\n    background: #000;\n}\n\n/* ── Video Actions ── */\n\n.post-video-actions {\n    display: flex;\n    gap: 0.75rem;\n    padding: 0.5rem 0;\n    justify-content: flex-end;\n}\n\n.btn-download-video {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n    font-weight: 600;\n    background: #3b82f6;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    text-decoration: none;\n    transition: background 0.2s;\n}\n\n.btn-download-video:hover {\n    background: #2563eb;\n    color: #fff;\n}\n\n/* ── Post Status Badges ── */\n\n.post-status-badge {\n    margin-top: 0.75rem;\n    padding: 0.5rem 0.75rem;\n    border-radius: 8px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    text-align: center;\n}\n\n.post-status-badge.approved {\n    background: rgba(34, 197, 94, 0.1);\n    color: #16a34a;\n    border: 1px solid rgba(34, 197, 94, 0.2);\n}\n\n.post-status-badge.queued {\n    background: rgba(59, 130, 246, 0.1);\n    color: #2563eb;\n    border: 1px solid rgba(59, 130, 246, 0.2);\n}\n\n.post-status-badge.queued .publish-time {\n    font-weight: 400;\n    font-size: 0.8rem;\n}\n\n.post-status-badge.rejected {\n    background: rgba(220, 53, 69, 0.08);\n    color: #dc3545;\n    border: 1px solid rgba(220, 53, 69, 0.2);\n}\n\n/* Orphan-approved badge: post is approved but no publication slot was\n   available. Surfaced alongside the green \"approved\" badge so the user\n   sees both states at once. */\n.post-status-badge.orphan {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: rgba(245, 158, 11, 0.1);\n    color: #b45309;\n    border: 1px solid rgba(245, 158, 11, 0.25);\n    flex-wrap: wrap;\n}\n\n.post-status-badge.orphan .btn-retry-scheduling {\n    border: 1px solid currentColor;\n    background: transparent;\n    color: inherit;\n    padding: 0.15rem 0.5rem;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    cursor: pointer;\n}\n\n.post-status-badge.orphan .btn-retry-scheduling:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Highlight card based on post status */\n.post-card.status-pending_validation {\n    border-color: #22c55e;\n    box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.2);\n}\n\n.post-card.status-approved,\n.post-card.status-queued {\n    border-color: #3b82f6;\n}\n\n.post-card.status-rejected {\n    border-color: #dc3545;\n    opacity: 0.7;\n}\n\n/* ── Generation Progress Banner (non-blocking) ── */\n\n.generation-banner {\n    position: sticky;\n    top: 0;\n    z-index: 100;\n    background: linear-gradient(135deg, #f8faff 0%, #f0f4ff 100%);\n    border: 1px solid #c7d2fe;\n    border-radius: 12px;\n    padding: 1.25rem 1.5rem;\n    margin-bottom: 1.5rem;\n    box-shadow: 0 2px 12px rgba(99, 102, 241, 0.1);\n    animation: banner-slide-in 0.4s ease;\n}\n\n@keyframes banner-slide-in {\n    from {\n        opacity: 0;\n        transform: translateY(-12px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.generation-banner-header {\n    margin-bottom: 0.75rem;\n}\n\n.generation-banner-title {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n}\n\n.generation-banner-title h3 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.generation-banner-subtitle {\n    margin: 0.25rem 0 0;\n    font-size: 0.85rem;\n    color: #64748b;\n}\n\n/* ── Generation Progress ── */\n\n.generation-progress {\n    margin-top: 1.5rem;\n    text-align: left;\n}\n\n.progress-bar-container {\n    width: 100%;\n    height: 8px;\n    background: #e2e8f0;\n    border-radius: 4px;\n    overflow: hidden;\n    margin-bottom: 0.75rem;\n}\n\n.progress-bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #6366f1, #8b5cf6);\n    border-radius: 4px;\n    transition: width 0.6s ease;\n    min-width: 2%;\n}\n\n.progress-stats {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n    flex-wrap: wrap;\n    font-size: 0.85rem;\n    color: #475569;\n    margin-bottom: 1rem;\n}\n\n.progress-stats span {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.progress-failed {\n    color: #ef4444 !important;\n    font-weight: 600;\n}\n\n.progress-posts-detail {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 0.5rem;\n}\n\n.progress-post-item {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.4rem 0.6rem;\n    border-radius: 8px;\n    background: #f8fafc;\n    font-size: 0.8rem;\n    border: 1px solid #e2e8f0;\n    transition: background 0.3s, border-color 0.3s;\n}\n\n.progress-post-item.status-generating_audio,\n.progress-post-item.status-generating_video {\n    background: #eef2ff;\n    border-color: #c7d2fe;\n}\n\n.progress-post-item.status-pending_validation {\n    background: #f0fdf4;\n    border-color: #bbf7d0;\n}\n\n.progress-post-item.status-audio_failed,\n.progress-post-item.status-video_failed,\n.progress-post-item.status-failed {\n    background: #fef2f2;\n    border-color: #fecaca;\n}\n\n.day-label {\n    font-weight: 600;\n    min-width: 30px;\n}\n\n.post-status-text {\n    color: #64748b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Skeleton Loading ── */\n\n@keyframes skeleton-shimmer {\n    0% {\n        background-position: -400px 0;\n    }\n\n    100% {\n        background-position: 400px 0;\n    }\n}\n\n.skeleton-line {\n    background: linear-gradient(90deg,\n            #e2e8f0 25%,\n            #f1f5f9 50%,\n            #e2e8f0 75%);\n    background-size: 800px 100%;\n    animation: skeleton-shimmer 1.8s ease-in-out infinite;\n    border-radius: 6px;\n}\n\n.skeleton-post-card {\n    background: #ffffff;\n    border: 1px solid #dbdbdb;\n    border-radius: 8px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    animation: skeleton-fade-in 0.4s ease both;\n}\n\n@keyframes skeleton-fade-in {\n    from {\n        opacity: 0;\n        transform: translateY(8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.skeleton-post-card .skeleton-card-header {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid #efefef;\n}\n\n.skeleton-post-card .skeleton-avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.skeleton-post-card .skeleton-header-text {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    flex: 1;\n}\n\n.skeleton-post-card .skeleton-header {\n    height: 14px;\n    width: 45%;\n}\n\n.skeleton-post-card .skeleton-sub {\n    height: 10px;\n    width: 30%;\n}\n\n.skeleton-post-card .skeleton-media {\n    width: 100%;\n    aspect-ratio: 9 / 16;\n    max-height: 420px;\n    border-radius: 0;\n}\n\n.skeleton-post-card .skeleton-caption-area {\n    padding: 0.75rem 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.skeleton-post-card .skeleton-label {\n    height: 10px;\n    width: 25%;\n    margin-bottom: 0.25rem;\n}\n\n.skeleton-post-card .skeleton-text-long {\n    height: 14px;\n    width: 100%;\n}\n\n.skeleton-post-card .skeleton-text-medium {\n    height: 14px;\n    width: 75%;\n}\n\n.skeleton-post-card .skeleton-text-short {\n    height: 14px;\n    width: 50%;\n}\n\n.skeleton-post-card .skeleton-tags {\n    display: flex;\n    gap: 0.375rem;\n    margin-top: 0.25rem;\n}\n\n.skeleton-post-card .skeleton-tag {\n    height: 18px;\n    width: 65px;\n    border-radius: 4px;\n}\n\n.skeleton-post-card .skeleton-btn-row {\n    display: flex;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem 0.75rem;\n    border-top: 1px solid #efefef;\n}\n\n.skeleton-post-card .skeleton-btn {\n    height: 34px;\n    flex: 1;\n    border-radius: 8px;\n}\n\n.skeleton-generating-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    padding: 1rem 1.25rem;\n    background: linear-gradient(135deg, #f8faff 0%, #f0f4ff 100%);\n    border: 1px solid #c7d2fe;\n    border-radius: 12px;\n    animation: banner-slide-in 0.4s ease;\n}\n\n.skeleton-generating-header .skeleton-gen-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.skeleton-generating-header .skeleton-gen-title {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n}\n\n.skeleton-generating-header .skeleton-gen-title h3 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #1e293b;\n}\n\n.skeleton-generating-header .skeleton-gen-subtitle {\n    font-size: 0.85rem;\n    color: #64748b;\n    margin: 0;\n}\n\n/* ═══════════ Mobile: Post Cards & Actions ═══════════ */\n\n@media (max-width: 640px) {\n    .scheduled-post-actions {\n        flex-wrap: wrap;\n        gap: 0.4rem;\n    }\n\n    .scheduled-post-actions button {\n        font-size: 0.72rem;\n        padding: 0.3rem 0.55rem;\n    }\n\n    .post-card-footer {\n        flex-wrap: wrap;\n        gap: 0.4rem;\n    }\n}\n\n@media (max-width: 380px) {\n    .scheduled-post-actions button {\n        font-size: 0.68rem;\n        padding: 0.25rem 0.45rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
